import { ROUTES } from "../../../../routes";
import { describeMoveToSetProgress } from "./describeMoveToSetProgress.js";
import { useOptionalMoveToSetRun } from "./MoveToSetRunProvider.js";
import { RunBanner } from "./RunBanner.js";

const BATCH_UPDATES_PATH = `${ROUTES.developer.pipelineBrowser}?tab=batch-updates`;

type MoveToSetRunBannerProps = {
  onNavigate: (path: string) => void;
};

export function MoveToSetRunBanner({ onNavigate }: MoveToSetRunBannerProps) {
  const run = useOptionalMoveToSetRun();
  if (!run?.running || run.sectionMounted) return null;
  const { runKind, dryRun, progress, stop } = run;
  const runType = runKind === "retry" ? "retry" : dryRun ? "dry run" : "apply";

  return (
    <RunBanner
      label="Move to set run"
      status={`Move testimonials to the set (${runType}): ${describeMoveToSetProgress(progress)}.`}
      linkPath={BATCH_UPDATES_PATH}
      linkLabel="Open Batch Updates"
      onNavigate={onNavigate}
      onStop={stop}
    />
  );
}
